export default __webpack_public_path__ + "static/media/property_187.0921878e.png";